<script>
import { constants } from '@src/constants/safehaven'
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
  props: {
    group: {
      type: Number,
      default: 0,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    noGutters: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      selectedTab: null,
      selectedCard: [],
      tabs: [
        { id: 0, value: 'Show all' },
        { id: 1, value: 'Medical History' },
        { id: 2, value: 'Medication' },
        { id: 3, value: 'Diagnostic' },
      ],
      menuItems: constants.healthRecordAddModel,
    }
  },
  computed: {
    menuItemsFiltered() {
      const show = Object.values(this.menuItems).filter((el) => {
        if (el.model_name === 'symptomcheaker') {
          return true
        }
        return el.show_menu
      })

      if (this.selectedTab) {
        return show.filter((el) => {
          return el.group === this.selectedTab
        })
      } else {
        return show
      }
    },
  },
  watch: {
    group(newValue, oldValue) {
      this.selectedTab = newValue
    },
    selectedCard: function(val) {
      this.selectEvent()
    },
  },
  mounted() {
    this.selectedTab = this.group
    this.selectedCard = this.menuItemsFiltered[0]
  },
  methods: {
    selectEvent() {
      this.$emit('select-changed', this.selectedCard)
    },
    selectAll() {
      this.selectedCard = this.menuItemsFiltered
      this.selectEvent()
    },
    unselectAll() {
      this.selectedCard = []
      this.selectEvent()
    },
  },
}
</script>

<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col
          v-for="item in menuItemsFiltered"
          :key="item.value"
          cols="12"
          sm="4"
          class="pa-0"
        >
          <v-item>
            <v-sheet style="background-color: transparent">
              <v-radio-group v-model="selectedCard">
                <v-radio :value="item">
                  <template v-slot:label>
                    <span :class="$style.radioLabel">{{
                      $t(item.menu_title)
                    }}</span>
                  </template>
                </v-radio>
                <span :class="$style.radiosubTitle">{{
                  $t(item.sub_title)
                }}</span>
              </v-radio-group>
            </v-sheet>
          </v-item>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.menuTab :hover {
  color: white;
  background: $color-theme-light-primary;
  border-radius: 24px;
}

.tab {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.25px;
}

.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}

.radioContainer {
  margin-top: 20px !important;
}

.radioLabel {
  font-size: 14px;
  font-weight: 600;
  color: #454648;
}
.radiosubTitle {
  margin-top: -10px;
  margin-left: 10%;
  font-size: 12px;
  font-weight: 400;
}

@media screen and (max-width: 960px) {
  .cardsContainer {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.hrCard {
  border-radius: 16px !important;
}

.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}

.cardText {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.75px;
}

.listText {
  font-size: 14px;
  color: #454648 !important;
  text-transform: capitalize !important;
}

.selectAllText {
  font-size: 14px;
  color: #454648 !important;
}
</style>
